module.exports = __webpack_public_path__ + "img/Feature.a68fe8e4.png";